import { render, staticRenderFns } from "./AdAccount.vue?vue&type=template&id=f9b56bd8"
import script from "./AdAccount.vue?vue&type=script&lang=ts"
export * from "./AdAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports